import React from 'react';

import List from './variables/List'

function Variables(){
	return(
	
			<List/>
			
	
	);
}

export default Variables;